import { Action } from 'redux';
import { combineEpics, Epic } from 'redux-observable';
import { catchError } from 'rxjs/operators';

import { navigationEpics } from './navigation';
import { appEpic } from '../../app/epics';
import { accountEpic } from '../../features/account/epics';
import { addressVerificationEpic } from '../../features/address-verification/epics';
import { analyticsEpic } from '../../features/analytics/epics';
import { applicationEpic } from '../../features/application/epics';
import { uploadDocumentsEpic, uploadFinancialDocumentsEpic } from '../../features/document-collection/epics';
import { startOrResumeApplicationEpic } from '../../features/fleet-verification/epics';
import { legalConsentEpic } from '../../features/legal-consent/epics';
import { personaEpic } from '../../features/persona/epics';
import { bankAccountLinkingEpics } from '../../features/revenue-verification/epics';
import { Services } from '../../services';
import { RootState } from '../index';

export type RootEpic = Epic<Action, Action, RootState, Services>;

const combinedEpic: RootEpic = combineEpics(
  accountEpic,
  addressVerificationEpic,
  analyticsEpic,
  appEpic,
  applicationEpic,
  bankAccountLinkingEpics,
  legalConsentEpic,
  navigationEpics,
  personaEpic,
  startOrResumeApplicationEpic,
  uploadDocumentsEpic,
  uploadFinancialDocumentsEpic,
);

export const rootEpic: RootEpic = (action$, state$, deps) =>
  combinedEpic(action$, state$, deps).pipe(
    catchError((error, source) => {
      console.error(error);
      return source;
    }),
  );
